{
  "connection": {
    "welcomeMessage": "Bienvenue, {{firstName}} !",
    "description": "Configurez Chirpee en 15 minutes et commencez à recueillir les retours des employés en temps réel.",
    "pill": {
      "setupNow": "Configurer",
      "connected": "Connecté",
      "completed": "Terminé"
    },
    "options": {
      "ssoConnected": {
        "title": "Connecter votre SSO",
        "description": "Configurez l’authentification unique pour gérer l’accès de votre organisation.",
        "tooltipTitle": "Texte d’aide",
        "buttonLabel": "Gérer"
      },
      "hrisConnected": {
        "title": "Connecter l'organigramme",
        "description": "Importez la structure de votre organisation pour activer des flux de travail automatisés.",
        "tooltipTitle": "Texte d’aide",
        "buttonLabel": "Configurer"
      },
      "messagingConnected": {
        "title": "Connecter un outil de communication",
        "description": "Collectez les retours des employés via les plateformes de communication de l’équipe.",
        "tooltipTitle": "Texte d’aide",
        "buttonLabel": "Configurer"
      },
      "billingSetup": {
        "title": "Configurer la facturation",
        "description": "Ajoutez vos informations de facturation et choisissez un plan adapté à vos besoins.",
        "tooltipTitle": "Texte d’aide",
        "buttonLabel": "Configurer"
      },
      "branding": {
        "title": "Image de marque de l’entreprise",
        "description": "Personnalisez l’image de votre entreprise pour une expérience cohérente.",
        "tooltipTitle": "Texte d’aide",
        "buttonLabel": "Configurer"
      }
    }
  },
  "billing": {
    "backToGettingStarted": "Retour à Getting Started",
    "title": "Configurer la facturation",
    "description": "Sélectionnez l’option de facturation qui convient le mieux à votre organisation.",
    "currencyLabel": "Devise :",
    "currencyPlaceholder": "Devise",
    "taxDisclaimer": "Tous les prix excluent les taxes applicables.",
    "freeTrial": {
      "title": "Commencez par un essai gratuit de 30 jours",
      "description": "Aucun frais avant la fin de votre essai. Collectez gratuitement votre premier mois d’insights employés."
    },
    "employeeCount": {
      "title": "Nombre d’employés",
      "hrisConnected": "HRIS connecté",
      "pendingHrisSync": "Synchronisation HRIS en attente",
      "readonlyCount": "{{count}} employés",
      "description": "Le nombre de sièges employés est dynamique et basé sur le nombre d’utilisateurs actifs synchronisés depuis votre système HRIS qui reçoivent des questions."
    },
    "plans": {
      "recommended": "Recommandé",
      "perEmployeeMonth": "par employé / mois",
      "employeeCountFormula": "{{count}} employés",
      "monthlyTotal": "Total mensuel",
      "perMonth": "/ mois",
      "launchingCheckout": "Lancement du checkout...",
      "monthly": {
        "title": "Plan mensuel",
        "subtitle": "Facturé mensuellement",
        "cta": "Sélectionner le plan mensuel"
      },
      "annual": {
        "title": "Plan annuel",
        "subtitle": "Facturé annuellement",
        "cta": "Sélectionner le plan annuel",
        "savingsBadge": "Économisez {{percent}} %",
        "savingsText": "Économisez {{amount}}/an avec {{count}} employés"
      }
    },
    "features": {
      "title": "Toutes les fonctionnalités incluses dans les deux plans",
      "comingSoon": "Bientôt disponible",
      "items": {
        "dailyQuestionDelivery": "Envoi quotidien de questions",
        "enterpriseSecurity": "Sécurité de niveau entreprise",
        "slackTeamsIntegration": "Intégration Slack et Teams",
        "analyticsDashboard": "Tableau de bord analytique complet",
        "teamInsights": "Insights d’équipe illimités",
        "hrisIntegration": "Intégration HRIS",
        "dedicatedSupport": "Support dédié",
        "surveyBuilder": "Créateur d’enquêtes"
      }
    },
    "socialProof": {
      "title": "Pourquoi les organisations choisissent le feedback continu",
      "cards": {
        "turnover": {
          "description": "Taux de rotation plus faibles dans les organisations avec feedback régulier",
          "source": "Gallup, 2023"
        },
        "managerEffectiveness": {
          "description": "Efficacité accrue des managers grâce aux insights employés continus",
          "source": "Harvard Business Review, 2022"
        },
        "profitMargins": {
          "description": "Marges bénéficiaires plus élevées dans les entreprises utilisant des systèmes de feedback continu",
          "source": "PwC, 2023"
        }
      }
    },
    "invoiceFooter": "Besoin d’une facturation sur facture ? Contactez-nous à <supportLink>support@chirpee.co</supportLink>",
    "complete": {
      "title": "Configuration du paiement",
      "description": "Votre configuration de paiement est en cours de confirmation. Revenez à Getting Started pour continuer l’onboarding."
    },
    "errors": {
      "chooseCurrency": "Choisissez une devise de facturation avant de continuer.",
      "stripeKeyMissing": "La clé publique Stripe n’est pas configurée.",
      "checkoutStartFailed": "Impossible de démarrer le checkout. Veuillez réessayer.",
      "setupLoadFailed": "Nous n’avons pas pu charger les détails de configuration de la facturation.",
      "retry": "Réessayer",
      "pricingUnavailable": "Les prix ne sont pas disponibles pour {{currency}}. Veuillez sélectionner une autre devise."
    }
  }
}
